import RWD002 from "../class/rwd002";
import customDrawerNav from "./drawerNav";
import customFormConfirm from "./formConfirm";
import fixNavObserver from "./fixnav";
import customSubNav from "./subNav";

const [d] = [document];

export default class CUSTOMIZE extends RWD002 {

  constructor(opt) {
    opt = Object.assign({
      // fixNavを指定すると、スクロール時に固定するクラスを付与する
      fixNav : '[data-role="fixNav"]',
    },opt);

    // 上位クラスのコンストラクタ呼び出し
    super(opt);

    // カスタム用drawerNavのインスタンス化
    this.drawerNav = new customDrawerNav(this.opt.drawerNav);

    // カスタム用サブナビ登録クラスのインスタンス化
    this.Subnav = new customSubNav(this.opt);

    // コメントフォーム用確認画面モーダルのインスタンス化
    this.formConfirm = new customFormConfirm(this.opt.formConfirm);

    this.customInit();
  }

  customInit() {

    // イベント一覧
    d.addEventListener('rwd002.beforeInit', () => false );
    d.addEventListener('rwd002.beforeDomready', () => false );
    d.addEventListener('rwd002.beforeWindowload', () => false );
    d.addEventListener('rwd002.zip2addr', () => false );
    d.addEventListener('drawerNav.beforeInit', () => false );
    d.addEventListener('collapseNav.beforeInit', () => false );
    d.addEventListener('Scroll.beforeInit', () => false );
    d.addEventListener('Scroll.scrollUp', () => false );
    d.addEventListener('Scroll.scrollDown', () => false );
    d.addEventListener('Lazydisp.beforeInit', () => false );
    
    // テンプレートインスタンスのプロミス
    this.promises.init.then( () => false );
    this.promises.domReady.then( () => false );
    this.promises.windowLoad.then( () => false );
    
    // テンプレートインスタンスの全非同期メソッドの完了時に実行
    this.promiseAll().then( () => false );

    // サブナビ登録サンプル
    d.addEventListener('rwd002.beforeDomready', () => {
      this.customSubnav();
      const fixnav = d.querySelector('.rwd002-fixNav');
      new fixNavObserver(fixnav);
    });

    $(() => {
      // htmlデータ読み込み
      $('[data-load-html]').loadHtml();
      
      // カレントメニュー
      $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});

      Promise.all([window.load['loadHtml']]).then( () => this.hashscroll());
    });
  }

  // サブメニュー追加サンプル(beforeDomreadyに登録して使用)
  customSubnav () {
    /**
     * サブナビ追加メソッド(グローバルナビとフッター)
     * ヘッダー・フッター内の[data-key]属性値をもつ要素すべてに対して、サブナビを追加する
     * 第一引数にセレクタを指定(rwd002.opt.gnav / rwd002.opt.fnav )
     * 第一引数にコンテンツ番号を指定(li[data-key])
     * アイテムの出力HTMLは"subnavItemTemplate"によって出力される
     * 第二引数の個別アイテムにHTMLを指定すると、デフォルトのHTMLを上書きする
     * 親要素liに[data-collapse="true"]を指定すると、サブナビを開閉するボタンを追加する
     */

    // header gnav用サブナビ追加
    this.Subnav.add(this.opt.gnav, 'content2', [
      // 標準出力
      // { label: 'サブメニュー01', href: '#'},
      // { label: 'サブメニュー02', href: '#'},
      // { label: 'サブメニュー03', href: '#'},

      // カスタマイズHTMLも追加可能
      { html: `<strong class="rwd002-subnav__title d-none d-lg-flex"><strong>COMPANY</strong><small>会社案内</small></strong>`
      },
      { html: `
        <li class="${this.Subnav.opt.subnavClass}-item">
          <a href="/company/" class="${this.Subnav.opt.subnavClass}-item__link">
          <figure class="img">
            <img src="/assets/img/company/company_subnav01@2x.jpg" alt="" width="100" height="100">
          </figure>
          <div class="body">
            <span class="text">ご挨拶</span>
          </div>
          </a>
        </li>`
      },
      { html: `
        <li class="${this.Subnav.opt.subnavClass}-item">
          <a href="/company/#outline" class="${this.Subnav.opt.subnavClass}-item__link">
            <figure class="img">
              <img src="/assets/img/company/company_subnav02@2x.jpg" alt="" width="100" height="100">
            </figure>
            <div class="body">
              <span class="text">会社概要</span>
            </div>
          </a>
        </li>`
      },
      { html: `
        <li class="${this.Subnav.opt.subnavClass}-item">
          <a href="/company/?mode=detail&article=2" class="${this.Subnav.opt.subnavClass}-item__link">
            <figure class="img">
              <img src="/assets/img/company/company_subnav03@2x.jpg" alt="" width="100" height="100">
            </figure>
            <div class="body">
              <span class="text">営業所</span>
            </div>
          </a>
        </li>`
      }
    ]);
    this.Subnav.add(this.opt.gnav, 'content3', [
      // 標準出力
      { html : `<strong class="rwd002-subnav__title d-none d-lg-flex"><strong>RECRUIT</strong><small>採用情報</small></strong>`},
      { label: '求める人物像', href: '/recruit/'},
      { label: '先輩社員インタビュー', href: '/recruit/?mode=detail&article=1'},
      { label: 'キャリアプラン/制度・環境', href: '/recruit/?mode=detail&article=2'},
      { label: '1日の流れ', href: '/recruit/?mode=detail&article=3'},
      { label: '募集要項', href: '/recruit/#requirement'}
    ]);

    // footer nav用サブナビ追加
    this.Subnav.add(this.opt.fnav, 'content2', [
      { label: '代表挨拶・会社概要・沿革', href: '/company/'},
      { label: '営業所一覧', href: '/company/?mode=detail&article=2'},
    ]);

    this.Subnav.add(this.opt.fnav, 'content3', [
      { label: '求める人物像', href: '/recruit/'},
      { label: '先輩社員インタビュー', href: '/recruit/?mode=detail&article=1'},
      { label: 'キャリアプラン/制度・環境', href: '/recruit/?mode=detail&article=2'},
      { label: '1日の流れ', href: '/recruit/?mode=detail&article=3'},
      { label: '募集要項', href: '/recruit/#requirement'}
    ]);
    this.Subnav.add(this.opt.fnav, 'content7', [
      { label: 'お問い合わせフォーム', href: '/inquiry/?mode=detail&article=1'},
      { label: 'エントリーフォーム', href: '/inquiry/?mode=detail&article=2'},
    ]);
  }

}

